// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gia-text{margin-top:13px;margin-bottom:13px;font-style:normal;font-weight:400;font-size:14px;line-height:20px}.gia-text a,.gia-text a:visited{color:inherit}", ""]);
// Exports
module.exports = exports;
